module.exports = __webpack_public_path__ + "img/dev_logo.5b50073b.png";